import Component from '../abstracts/Component';
import brightcovePlayerLoader from '@brightcove/player-loader';
import { isMobile, MobileBreakpoint } from '../utils/MobileUtils';

/**
 Video brightcove
 */
export default class VideoBrightcoveComponent extends Component {
  get COMPONENTNAME() {
    return 'VideoBrightcoveComponent';
  }

  static get SELECTORS() {
    return {
      videoWrapper: '.brightcove-wrapper',
      videoplayer: 'video-js',
    };
  }

  static getOpts(playerElement) {
    let isMobileVar;
    let data = playerElement.dataset;
    if (data.tabletMobile == 'true') {
      isMobileVar = isMobile(MobileBreakpoint.Max1023);
    } else {
      isMobileVar = isMobile(MobileBreakpoint.Max767);
    }

    return {
      aspectratio:
        isMobileVar && data.videoMobileId !== ''
          ? data.aspectratioMobile || '16:9'
          : data.aspectratio,
      playerID: data.playerId || 'default',
      embed: data.embed,
      controls: convertToBoolean(data.controls),
      videoID:
        isMobileVar & (data.videoMobileId !== '')
          ? data.videoMobileId
          : data.videoId,
      autoStart: convertToBoolean(data.autostart),
      startOnScroll: convertToBoolean(data.startOnScroll),
      videoRepeat: convertToBoolean(data.repeat),
      playlistID: data.playlistId,
      applicationID: data.applicationId,
      muted: convertToBoolean(data.muted),
      poster: data.videoPoster,
      hideVideo: convertToBoolean(data.hideVideo),
      accountId: data.accountId,
      width: data.width || '100%',
    };
  }

  static isElementInViewport(el) {
    var pp = $(el).offset();
    var top = pp.top;
    var left = pp.left;
    var width = $(el).outerWidth();
    var height = $(el).outerHeight(true);

    return (
      top < window.pageYOffset + window.innerHeight &&
      left < window.pageXOffset + window.innerWidth &&
      top + height > window.pageYOffset &&
      left + width > window.pageXOffset
    );
  }

  /**
   *
   * @param myPlayer player from success.ref
   */
  bindEvents(myPlayer) {
    let videoJsEl = this.wrapper.querySelector(
      VideoBrightcoveComponent.SELECTORS.videoplayer
    );

    if (videoJsEl) {
      let container = this.wrapper; // container of brightcove player
      let controls = container.querySelector('.custom-controls');
      let showControls = VideoBrightcoveComponent.getOpts(this.wrapper).controls;
      if (controls !== null && controls !== undefined) {
        const playControl = controls.querySelector('.custom-play');
        const audioControl = controls.querySelector('.custom-audio');
        const timeControl = controls.querySelector('.custom-time');
        const barControl = controls.querySelector('.custom-progress');
        const fullScreenControl = controls.querySelector('.custom-fullscreen');

        if (myPlayer !== undefined && showControls === true) {
          controls.classList.remove('hide');

          // TIME
          let time = myPlayer.$('.vjs-current-time');
          timeControl.append(time);

          // PROGRESS-BAR
          let bar = myPlayer.$('.vjs-progress-control');
          barControl.append(bar);

          // PLAY-PAUSE
          // icon play/pause when the video starts
          let isPaused = myPlayer.paused();
          isPaused
            ? controls.classList.remove('play')
            : controls.classList.add('play');
          
          // Update aria-label based on initial state
          this.updatePlayButtonAriaLabel(playControl, isPaused);
          
          // listen to play/pause video
          myPlayer.on('play', () => {
            controls.classList.add('play');
            this.updatePlayButtonAriaLabel(playControl, false);
          });
          myPlayer.on('pause', () => {
            controls.classList.remove('play');
            this.updatePlayButtonAriaLabel(playControl, true);
          });
          // play/pause on custom control click
          playControl.addEventListener('click', () => {
            let isPaused = myPlayer.paused();
            if (isPaused) {
              myPlayer.play();
            } else {
              myPlayer.pause();
            }
          });

          // AUDIO
          // audio control when the video starts
          let isMuted = myPlayer.muted();
          isMuted
            ? controls.classList.add('mute')
            : controls.classList.remove('mute');
          
          // Update aria-label based on initial state
          this.updateAudioButtonAriaLabel(audioControl, isMuted);
          
          // mute/unmute with custom control click
          audioControl.addEventListener('click', () => {
            isMuted = myPlayer.muted();
            if (isMuted) {
              this.unmuteVideo();
              controls.classList.remove('mute');
              this.updateAudioButtonAriaLabel(audioControl, false);
            } else {
              this.muteVideo();
              controls.classList.add('mute');
              this.updateAudioButtonAriaLabel(audioControl, true);
            }
          });

          //FULLSCREEN
          fullScreenControl.addEventListener('click', () => {
            const isFullScreen = myPlayer.isFullscreen();
            if (isFullScreen) {
              myPlayer.exitFullscreen();
            } else {
              myPlayer.requestFullscreen();
            }
          });

          if (isMobile(MobileBreakpoint.Max1023)) {
            this.showControlsMobile(container, videoJsEl);
          }
        }
      }
      $(window).on('resize scroll', this.resizeScrollHandler);
    }
  }

  resizeScrollHandler(e) {
    let videoJsEl = this.wrapper.querySelector(
      VideoBrightcoveComponent.SELECTORS.videoplayer
    );
    if (videoJsEl) {
      let opts = VideoBrightcoveComponent.getOpts(this.wrapper); // container of brightcove player
      if (this.myPlayer) {
        if (VideoBrightcoveComponent.isElementInViewport(videoJsEl)) {
          if (opts.startOnScroll) {
            this.playVideo();
          }
        } else {
          if (!this.myPlayer.hasClass('vjs-waiting')) {
            this.pauseVideo();
          }
        }
      }
    }
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.bindEvents = this.bindEvents.bind(this);
    this.resizeScrollHandler = this.resizeScrollHandler.bind(this);
    this.wrapper = this.$component.querySelector(
      VideoBrightcoveComponent.SELECTORS.videoWrapper
    );
    this.intoGallery = this.wrapper.dataset.intoGallery === 'true';
    this.myPlayer = null;
  }

  initPlayer(ele) {
    $(window).off('resize scroll', this.resizeScrollHandler);
    let opts = VideoBrightcoveComponent.getOpts(this.wrapper);
    let videoPoster = '';
    // console.info('Init: ', opts);

    if (opts.poster) {
      videoPoster = opts.poster;
    }

    // brightcovePlayerLoader.reset(); // this reset removes all brightcove videos in page

    //https://support.brightcove.com/brightcove-player-loader
    // https://docs.brightcove.com/brightcove-player/1.x/Player.html

    brightcovePlayerLoader({
      refNode: this.wrapper,
      refNodeInsert: 'prepend', //prepend because of custom controls into wrapper
      accountId: opts.accountId, //required - A Video Cloud account ID
      playerId: opts.playerID, //required
      videoId: opts.videoID,
      embedType: opts.embed, //in-page or iframe
      applicationId: opts.applicationID, // The application ID to be applied to the generated embed.
      media: opts.media,
      embedOptions: {
        tagName: 'video-js', // video-js or video - default is video-js
        unminified: false, // for debugging: use the un-minified version of the player
        responsive: {
          aspectRatio: opts.aspectratio,
          maxWidth: opts.width,
        },
      },
      options: {
        autoplay: convertToBoolean(opts.autoStart),
        controls: convertToBoolean(opts.controls),
        loop: convertToBoolean(opts.videoRepeat),
        muted: convertToBoolean(opts.muted),
        poster: videoPoster,
      },
    })
      .then(success => {
        this.myPlayer = success.ref;
        if (opts.poster) {
          videoPoster = opts.poster;
        } else {
          videoPoster = this.myPlayer.mediainfo.poster;
        }

        this.myPlayer.on('error', error => {
          console.info('[Video Brightcove] error general', error);
        });

        this.myPlayer.on('loadstart', () => {
          this.myPlayer.poster(videoPoster);
        });

        this.myPlayer.on('loadedmetadata', () => {
          if (!opts.controls) {
            this.myPlayer.controlBar.hide();
          }
          if (opts.autoStart === true) {
            let playVideo = this.myPlayer.play(); // Browser/platform autoplay policies - https://support.brightcove.com/autoplay-considerations

            if (playVideo !== undefined) {
              // check if the video played, otherwise I'll put the video on mute
              playVideo
                .then(() => {
                  this.myPlayer.muted(opts.muted);
                })
                .catch(() => {
                  this.muteVideo();
                })
                .finally(() => {
                  console.info('autostart', opts.autoStart);

                  if (VideoBrightcoveComponent.isElementInViewport(this.wrapper)) {
                    this.myPlayer.currentTime(0);
                    this.myPlayer.play();
                  } else {
                    this.myPlayer.pause();
                  }
                });
            }
          }
        });

        this.myPlayer.on('loadeddata', () => {
          this.bindEvents(this.myPlayer);
        });

        this.myPlayer.on('ended', () => {
          if (opts.hideVideo === true) {
            this.wrapper.style.backgroundImage = `url('${this.wrapper.dataset.videoPoster}')`;
            this.myPlayer.hide();
            this.myPlayer.controlBar.hide();
          } else {
            this.myPlayer.currentTime(0);
          }

        });
      })
      .catch(error => {
        console.info('[Video Brightocove] Loading failed', error);
      });
  }

  muteVideo() {
    if (this.myPlayer) {
      this.myPlayer.muted(true);
    }
  }

  unmuteVideo() {
    if (this.myPlayer) {
      this.myPlayer.muted(false);
    }
  }

  /**
   * Updates the aria-label of the play/pause button based on current state
   * @param {HTMLElement} button - The play/pause button element
   * @param {boolean} isPaused - Whether the video is currently paused
   */
  updatePlayButtonAriaLabel(button, isPaused) {
    if (button) {
      const label = isPaused ? button.dataset.playLabel : button.dataset.pauseLabel;
      button.setAttribute('aria-label', label);
    }
  }

  /**
   * Updates the aria-label of the mute/unmute button based on current state
   * @param {HTMLElement} button - The mute/unmute button element
   * @param {boolean} isMuted - Whether the video is currently muted
   */
  updateAudioButtonAriaLabel(button, isMuted) {
    if (button) {
      const label = isMuted ? button.dataset.unmuteLabel : button.dataset.muteLabel;
      button.setAttribute('aria-label', label);
    }
  }

  playVideo() {
    if (this.myPlayer) {
      this.myPlayer
        .play()
        .then(() => {
          this.myPlayer.play();
        })
        .catch(error => {
          this.unmuteVideo();
          this.myPlayer.play();
        });
    }
  }

  pauseVideo() {
    if (this.myPlayer) {
      this.myPlayer.pause();
    }
  }

  showControlsMobile(container, videoJsEl) {
    const options = {
      attributes: true
    }

    function callback(mutationList, observer) {
      mutationList.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (videoJsEl.classList.contains('vjs-user-active')) {
            container.classList.add('show-controls-mobile');
          } else {
            container.classList.remove('show-controls-mobile');
          }
        }
      });
    }

    const observer = new MutationObserver(callback);
    observer.observe(videoJsEl, options);
  }

  setup() {
    if (this.wrapper) {
      this.initPlayer(this.wrapper);
    }
  }

  init() {
    // BrightCove: https://github.com/brightcove/player-loader
    this.setup();
  }

  render() {
    super.render();
    this.init();
  }
}

function convertToBoolean(value) {
  if(typeof value === "boolean") {
    return value;
  }
  if(typeof value === "string" && value === "true") {
    return true;
  }
  return false;
}
